import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './styles.module.scss';

const verifiedIconSrc = new URL('../../../img/verified-blue.svg', import.meta.url).href;

interface VerifiedBadgeProps {
  /** Компания прошла проверку — иначе ничего не рисуем */
  isVerified?: boolean | null;
  size?: 'small' | 'medium';
  className?: string;
}

/**
 * Отметка «компания верифицирована» рядом с названием компании.
 * Одна на всё приложение: биржа, карточка объявления, страница компании, профиль.
 */
const VerifiedBadge = ({ isVerified, size = 'medium', className }: VerifiedBadgeProps) => {
  const { t } = useTranslation();

  if (!isVerified) {
    return null;
  }

  return (
    <img
      src={verifiedIconSrc}
      alt={t('company.verified')}
      title={t('company.verified')}
      className={cn(styles.icon, styles[`icon--${size}`], className)}
    />
  );
};

export default VerifiedBadge;
